import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";

export const ZendeskShape = {
  api_email: Yup.string().label("API Email Address").required(),
  api_token: Yup.string().label("API Token").required(),
  zendesk_subdomain: Yup.string().label("Zendesk Subdomain").url().min(10).max(255).required(),
  priority: Yup.string().label("Ticket Priority").optional(),
  ticket_type: Yup.string().label("Ticket Type").optional(),
  tags: Yup.string().label("Tags").max(1000).optional(),
  autoresolve: Yup.boolean().label("Auto-solve Ticket").optional(),
};

export interface ZendeskInput {
  api_email: string;
  api_token: string;
  zendesk_subdomain: string;
  priority?: string;
  ticket_type?: string;
  tags?: string;
  autoresolve?: boolean;
}

export const ZendeskDefaults = {
  zendesk_subdomain: "https://",
  priority: "",
  ticket_type: "",
  autoresolve: true,
};

yupResolver<ZendeskInput>(Yup.object().shape(ZendeskShape));
